export default "__VITE_ASSET__DlrfVi6L__"